import { GeneralService } from './../services/general.service';
import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-latw',
  templateUrl: './latw.component.html',
  styleUrls: ['./latw.component.css']
})
export class LatwComponent implements OnInit {

  
  constructor(private commonScriptComponent:CommonScriptComponent, private generalService:GeneralService) { }
  base_url = this.generalService.BASE_URL;
  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/latw/latw.component.ts